import React from "react";
import styles from "./Header.module.scss";
import { Context } from "../Store";
import useMediaQuery from "../hooks/useMediaQuery";
import { formatDate } from "../utils/helpers";

const Header = (props) => {
  const state = React.useContext(Context);
  const isDesktop = useMediaQuery("(min-width: 768px)");

  return (
    <>
      <div className={styles.header}>
        <div className={styles.photo}>
          <div className={styles.venuePhotoContainer}>
            <img
              src={"./img/es-stories_venue-header_" + state.venue.toLowerCase() + ".jpg"}
              alt={state.venue + " Photo"}
            />
          </div>
        </div>

        <div className={styles.logoContainer}>
          <div className={styles.logo}>
            <img src="./img/es-logo-full.svg" alt="Stories" />
          </div>
          <div className={styles.storyInfo}>
            <div className={styles.storyDate}>{formatDate(state.date, styles.dateSuffix)}</div>
            <div className={styles.oneLine}>
              <div>{state.venueDisplayName || state.venue}</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                <circle cx="2" cy="2" r="2" fill="#FACFA5" />
              </svg>
              <div>{state.players.length} Players</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
